import { render } from "./Ayah.vue?vue&type=template&id=03e16b12"
import script from "./Ayah.vue?vue&type=script&lang=js"
export * from "./Ayah.vue?vue&type=script&lang=js"
script.render = render

export default script